import { Link, useLocation } from "react-router";
import { Fragment } from "react";

import { type Crumb, normalizeCrumbs } from "@/lib/breadcrumbs";

import "./Breadcrumbs.css";

export type { Crumb };

/**
 * Het kruimelpad uit de detailschermen: Objecten > Complex > Object.
 *
 * De huidige pagina staat er wél in — anders verdwijnt hij van het scherm
 * zodra je erheen navigeert — maar zonder link en met `aria-current="page"`.
 */
export function Breadcrumbs({ items: aangeleverd }: { items: Crumb[] }) {
  const { pathname } = useLocation();
  const items = normalizeCrumbs(aangeleverd, pathname);
  if (items.length === 0) return null;

  return (
    <nav className="atl-breadcrumbs" aria-label="Kruimelpad">
      <ol>
        {items.map((crumb, index) => {
          const isLast = index === items.length - 1;
          return (
            <Fragment key={`${crumb.label}-${index}`}>
              <li>
                {crumb.to && !isLast ? (
                  <Link to={crumb.to}>{crumb.label}</Link>
                ) : (
                  <span aria-current={isLast ? "page" : undefined}>{crumb.label}</span>
                )}
              </li>
              {!isLast && (
                <li aria-hidden className="atl-breadcrumbs__separator">
                  {/* Stijl A: een middenpunt, zoals "Ons bezit · Vastgoed". */}
                  ·
                </li>
              )}
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}

